let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h9ZsZ")).then(() => parcelRequire('9D3Wg'));